import { alpha, styled } from '@mui/material';
import { FileExtension } from '../file-extension';

export type DocumentOptionProps = {
  document?: string;
  name?: string;
  bordered?: boolean;
};

const Root = styled('div', {
  shouldForwardProp: (prop) => prop !== 'bordered',
})<{ bordered: boolean }>(({ theme, bordered }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: 4,
  borderRadius: 4,
  background: 'transparent',
  transition: '0.3s',
  // Was `var(--neutrals-dark-10, …)` — that custom property is defined nowhere in the repo,
  // so only the rgba fallback ever rendered.
  ...(bordered && { border: `1px solid ${alpha(theme.palette.primary.darker, 0.1)}` }),
  '&:hover': {
    background: alpha(theme.palette.primary.darker, 0.07),
  },
}));

const Name = styled('span')(({ theme }) => ({
  fontSize: 12,
  fontWeight: 700,
  lineHeight: '13px',
  letterSpacing: 0,
  color: theme.palette.primary.darker,
}));

const DocumentOption = ({ document, name, bordered = false }: DocumentOptionProps) => {
  return (
    <Root bordered={bordered}>
      <FileExtension document={document || name || ''} />
      <Name>{name || document}</Name>
    </Root>
  );
};

export default DocumentOption;
